import Authentication from './Authentication';

export default Authentication;